__turbopack_context__.v({
  "helios-video-trigger": "hoQhvG_helios-video-trigger",
  "helios-video-trigger--reveal-frame": "hoQhvG_helios-video-trigger--reveal-frame",
  "helios-video-trigger--text-only": "hoQhvG_helios-video-trigger--text-only",
  "helios-video-trigger__icon": "hoQhvG_helios-video-trigger__icon",
});
